import React from 'react';

import { states } from 'utils';

import { FilterLabel } from './FilterLabel';

interface FilterStateLabelsProps {
    stateAbbriviations: string[];
    onRemove: (stateAbbriviation: string) => void;
}

export const FilterStateLabels = ({ stateAbbriviations, onRemove }: FilterStateLabelsProps) => {
    return (
        <>
            {states
                .filter((state) => stateAbbriviations.includes(state.abbreviation))
                .map(({ abbreviation, name }) => (
                    <FilterLabel
                        key={abbreviation}
                        label={`${abbreviation} ${name}`}
                        onRemove={() => onRemove(abbreviation)}
                    />
                ))}
        </>
    );
};
